import { createSystem, defaultConfig } from '@chakra-ui/react';

import { globalCss } from './global';

const system = createSystem(defaultConfig, {
  //.This is disabled because we want full control over the global overrides;
  // the reason is that preflight: true CSS reset messes up the styles of our
  // SVG objects and there's no easy way to override it.
  preflight: false,
  globalCss,
  theme: {
    breakpoints: {
      base: '0px',
      sm: '480px',
      md: '768px',
      lg: '960px',
      xl: '1200px',
      xxl: '1620px',
    },
    tokens: {
      colors: {
        blue: {
          50: { value: '#E6F2F8' },
          100: { value: '#CCE4F1' },
          200: { value: '#99C9E3' },
          300: { value: '#66ADD4' },
          400: { value: '#3392C6' },
          500: { value: '#0077B8' },
          600: { value: '#1B71A0' },
          700: { value: '#366B87' },
          800: { value: '#24475A' },
          900: { value: '#12242D' },
        },
        green: {
          50: { value: '#E6F6ED' },
          100: { value: '#CCEDDB' },
          200: { value: '#99DAB7' },
          300: { value: '#66C894' },
          400: { value: '#33B570' },
          500: { value: '#00A34C' },
          600: { value: '#028139' },
          700: { value: '#035E25' },
          800: { value: '#053C12' },
          900: { value: '#031E09' },
        },
        red: {
          50: { value: '#FDF4FE' },
          100: { value: '#FBE7F4' },
          200: { value: '#EEA3BE' },
          300: { value: '#E56C94' },
          400: { value: '#DB3669' },
          500: { value: '#D1003F' },
          600: { value: '#A70032' },
          700: { value: '#7D0026' },
          800: { value: '#540019' },
          900: { value: '#2A000D' },
        },
        yellow: {
          50: { value: '#FFFCF5' },
          100: { value: '#F7EFDA' },
          200: { value: '#E7D4A3' },
          300: { value: '#D8B96D' },
          400: { value: '#C89F36' },
          500: { value: '#B88400' },
          600: { value: '#936A00' },
          700: { value: '#6E4F00' },
          800: { value: '#4A3500' },
          900: { value: '#251A00' },
        },
        gray: {
          50: { value: '#F7FAFC' },
          100: { value: '#EDF2F7' },
          200: { value: '#E2E8F0' },
          300: { value: '#CBD5E0' },
          400: { value: '#A0AEC0' },
          500: { value: '#718096' },
          600: { value: '#4A5568' },
          700: { value: '#2D3748' },
          800: { value: '#1A202C' },
          900: { value: '#171923' },
        },
      },
      fonts: {
        heading: { value: `'Montserrat', sans-serif` },
        body: { value: `'Inter', sans-serif` },
      },
      radii: {
        sm: { value: '2px' },
        md: { value: '4px' },
        lg: { value: '8px' },
        xl: { value: '16px' },
      },
    },
  },
});

export default system;
